import React from "react";
import { StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import * as Colors from "../styles/colors";

export default function ButtonBack({navigation, black = true}){
    return <Icon name={"chevron-back"}
    size={32}
    color={black ? Colors.BLACK : Colors.WHITE}
    style={styles.iconBack}
    onPress={() => navigation.goBack()} 
    />
}

const styles = StyleSheet.create({
    iconBack: {
        position: "absolute",
        left: 5,
        top: 42
    }
})